import script from "./TestimonialsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialsCarousel.vue?vue&type=style&index=0&id=345ae3c5&scoped=true&lang=css"
import "./TestimonialsCarousel.vue?vue&type=style&index=1&id=345ae3c5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345ae3c5"]])

export default __exports__